import { Box, Link, NeoColor, P3 } from "@noom/wax-component-library";

type TreatmentDetailErrorPanelProps = {
  message: string;
  retryLabel: string;
  onRetry: () => void;
};

/**
 * Detail-page error state. Replaces the prior reuse of
 * `TreatmentCardError`, which renders a card-shaped placeholder that
 * looks out of place on the single-treatment detail layout. Centered
 * message + inline retry link to fit the rest of the detail layout's
 * vertical rhythm.
 */
export const TreatmentDetailErrorPanel = ({
  message,
  retryLabel,
  onRetry,
}: TreatmentDetailErrorPanelProps) => (
  <Box
    width="100%"
    pt={8}
    textAlign="center"
    data-testid="treatment-detail-error"
  >
    <P3 color={NeoColor.greyscale.black} mb={2}>
      {message}{" "}
      <Link
        href="#"
        color={NeoColor.blue.lagoon}
        fontSize="inherit"
        fontWeight="medium"
        lineHeight="inherit"
        cursor="pointer"
        onClick={(event) => {
          event.preventDefault();
          onRetry();
        }}
      >
        {retryLabel}
      </Link>
    </P3>
  </Box>
);
